import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../Pages/User/Dashboard/index";
import Mileage from "../Pages/User/Mileage/index";
import Fuel from "../Pages/User/Fuel/index";
import Idle from "../Pages/User/Idle/index";
import Sensor from "../Pages/User/Sensor/index";
import ServRem from "../Pages/User/Serv&Rem/index";
import FuelEfficiency from "../Pages/User/FuelEfficiency";
import DecisionEngine from "../Pages/User/DecisionEngine";
import MoreAnalysis from "../Pages/User/MoreAnalysis";
import Settings from "../Pages/User/Settings";
import { UserContext } from "../App";

const UserRoutes = () => {
  const { userPages } = useContext(UserContext);

  const findroute = () => {
    return userPages[0]?.split("_").join("-");
  };

  return (
    <Routes>
      {userPages?.includes("dashboard") && (
        <Route path="/dashboard" element={<Dashboard />} />
      )}
      {userPages?.includes("mileage") && (
        <Route path="/mileage" element={<Mileage />} />
      )}
      {userPages?.includes("fuel") && <Route path="/fuel" element={<Fuel />} />}
      {userPages?.includes("idle") && <Route path="/idle" element={<Idle />} />}
      {userPages?.includes("fuel_efficiency") && (
        <Route path="/fuel-efficiency" element={<FuelEfficiency />} />
      )}
      {userPages?.includes("sensor") && (
        <Route path="/sensor" element={<Sensor />} />
      )}
      {userPages?.includes("servicing_reminder") && (
        <Route path="/servicing-reminder" element={<ServRem />} />
      )}
      {userPages?.includes("decision_engine") && (
        <Route path="/decision-engine" element={<DecisionEngine />} />
      )}
      {userPages?.includes("more_analysis") && (
        <Route path="/more-analysis" element={<MoreAnalysis />} />
      )}
      <Route path="/settings" element={<Settings />} />

      <Route path="*" element={<Navigate to={findroute()} />} />
    </Routes>
  );
};

export default UserRoutes;
